<template>
  <div class="pan-zoom">
    <div ref="scene">
      <slot />
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue';
import panzoom from 'panzoom';

export default {
  name: 'PanZoom',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['init', 'zoom', 'pan', 'panstart'],
  data() {
    return { instance: null };
  },
  mounted() {
    const options = {
      ...this.options,
      autocenter: this.options.autocenter ?? this.options.autoCenter,
    };
    delete options.autoCenter;

    this.instance = markRaw(panzoom(this.$refs.scene, options));
    this.instance.on('zoom', () => this.$emit('zoom', this.instance));
    this.instance.on('pan', () => this.$emit('pan', this.instance));
    this.instance.on('panstart', (event) => this.$emit('panstart', event));
    this.$emit('init', this.instance);
  },
  beforeUnmount() {
    this.instance?.dispose();
  },
};
</script>
